module.exports = __webpack_public_path__ + "static/media/step6.d2632df0.png";